<template>
    <v-container class="pa-0 img">
      <!-- <v-carousel
        cycle
        class="slider"
        height="137"
        hide-delimiter-background
        show-arrows-on-hover
      >
        <v-carousel-item>
          <a href="https://cafebazaar.ir/app/com.abriron.p3integrator" target="_blank">
            <img
              src="@/assets/dashboard/img1.png"
              class="w-100"
            />
          </a>
        </v-carousel-item>
        <v-carousel-item>
          <a href="https://cafebazaar.ir/app/com.abriron.p3integrator" target="_blank">
            <img
              src="@/assets/dashboard/img1.png"
              class="w-100"
            />
          </a>
        </v-carousel-item>
      </v-carousel> -->
      <a href="https://cafebazaar.ir/app/com.abriron.p3integrator" target="_blank">
        <img
          src="@/assets/dashboard/img1.png"
          class="w-100"
        />
      </a>
      <v-card class="ma-0 pa-4 mt-1">
          <v-list class="pa-0" v-if="items != undefined && items != null">
              <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  class="pa-0 mb-3"
              >
                  <v-list-item-content class="pa-0">
                      <v-container class="pa-0 d-flex gap-2">
                          <div class="box">
                              <a :href="item.link" target="_blank">
                                <img :src="item.image" />
                              </a>
                          </div>
                          <div>
                              <a :href="item.link" style="color: #000 !important;" target="_blank">
                                <v-card-text class="pa-0 text-body-2">{{ item.title.length > 30 ? item.title.substring(0, 30) + '...' : item.title }}</v-card-text>
                              </a>
                              <v-card-text class="pa-0 text-caption text--disabled">{{ item.content.length > 30 ? item.content.substring(0, 30) + '...' : item.content }}</v-card-text>
                          </div>
                      </v-container>
                  </v-list-item-content>
              </v-list-item>
          </v-list>
      </v-card>
      <v-card class="ma-0 pa-3 wrapper mt-3">
          <v-container
            :class="[ $store.state.isMenuExpanded ? 'align-center flex-column' : 'align-start']"
            class="pa-0 d-flex gap-2"
          >
              <img src="@/assets/dashboard/suport.png" style="width: 75px"/>
              <div>
                  <v-card-text class="pa-0 text-body-1" :class="{ 'text-end': !$vuetify.rtl }">{{ $t('contact-support') }}</v-card-text>
                  <v-card-text class="pa-0 text-caption mt-1" style="color: rgb(255 255 255 / 78%);" :class="{ 'text-end': !$vuetify.rtl }">
                    {{ $t('Abariron support is always by your side to manage your business in the best way.') }}
                  </v-card-text>
                  <div class="mt-2 w-100">
                    <v-btn
                      color="white"
                      outlined
                      class="w-100"
                      @click="goTo('userSupport')"
                    >
                    {{ $t('Send a support message') }}
                    </v-btn>
                  </div>
              </div>
          </v-container>
      </v-card>
      <!--<v-card class="ma-0 pa-3 mt-3">
            <v-container class="pa-0 d-flex align-center gap-2">
                <div>
                    <v-card-text class="pa-0 text-body-1">حساب کاربری</v-card-text>
                    <v-card-text class="pa-0 text-body-2">برای دسترسی به خدمات بهتر لطفا اطلاعات حساب کاربر خود را کامل کنید</v-card-text>
                </div>
                <div>
                </div>
            </v-container>
            <v-card-text class="pa-0 text-body-1 mt-3">01 اطلاعات هویتی</v-card-text>
            <ul style="list-style-type: none;" class="mt-2">
                <li>وارد کردن ایمیل</li>
                <li>نوع کسب و کار خود را وارد کنید</li>
                <li>اطلاعات هویتی خود را تکمیل کنید</li>
            </ul>
            <v-btn
                color="primary"
                outlined
                class="w-100 mt-3"
            >
            برو به تنظیمات
            </v-btn>
        </v-card>-->
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: []
    }
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$axios.get(this.$endpoint + 'getdetail', {
        params: {
          select: 'getNews'
        }
      })
        .then(r => {
          this.items = r.data.data
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    goTo (to) {
      this.$router.push({ name: to }).catch(() => {})
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.box img {
    width: 45px;
    height: 45px;
    border-radius: 10px;
}
.v-list {
    max-height: 286px;
    overflow: auto;
}
.v-list::-webkit-scrollbar {
  display: none;
}
.wrapper {
    background-color: #00664D;
    padding: 10px;
    color: #fff;
}
.wrapper .box {
    display: flex;
    align-content: center;
    justify-content: center;
    background-color: #8bbf9c;
    padding: 3px;
    width: 125px;
    height: 55px;
    border-radius: 10px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
.slider ::v-deep .v-btn--icon.v-size--default {
  height: 25px;
  width: 25px;
}
::v-deep .v-btn--icon.v-size--default .v-icon {
  font-size: 23px !important;
}
::v-deep .v-icon.mdi-circle {
  font-size: 15px !important;
}
</style>
